import { IUserData } from "../User/IUserData";

export interface IHistoryActivityApiResponse {
  Action: HistoryActivityActionEnum;
  TopicId: string;
  ItemName: string;
  From: IHistoryActivityDetail;
  To: IHistoryActivityDetail;
  DateTimeUtc: Date;
  Author: IUserData;
}

export interface IHistoryActivityDetail {
  Value: string;
  DisplayValue: string | null;
}

export enum HistoryActivityActionEnum {
  TopicCreated = 0,
  TopicStatusUpdated = 1,
  TopicUpdated = 2,
  TopicTitleUpdated = 3,
  TopicCommunicationTypeUpdated = 4,
  TopicDescriptionUpdated = 5,
  TopicAssignedUsersUpdated = 6,
  TopicDisciplinesUpdated = 7,
  TopicDueDateUpdated = 8,
  TopicVisibilityUpdated = 9,
  TopicPriorityUpdated = 10,
  TopicLocationUpdated = 11,
  TopicAttachmentAdded = 12,
  TopicAttachmentDeleted = 13,
  TopicStageUpdated = 14
}

export interface IHistoryActivityRequestList {
  topicId: string;
}

export interface IHistoryActivityResponseList {
  histories: IHistoryActivityApiResponse[];
}
